/* tslint:disable */
/* eslint-disable */
/**
 * Payment Service API
 * 통합 정리된 결제 서비스 API 명세 - 완전 React 마이그레이션  **주요 개선사항:** - 모든 Thymeleaf 페이지를 REST API로 변환 - 기능별 그룹화된 경로 구조 - 표준화된 응답 형식 - React SPA 완전 지원  **API 구조:** - 결제수단 관리: `/api/v1/payment-methods/_*` - 구독 관리: `/api/v1/subscriptions/_*`  - 플랜 관리: `/api/v1/plans/_*` - 주문 관리: `/api/v1/orders/_*` - 대시보드: `/api/v1/dashboard/_*` - NicePay 결제: `/api/v1/payment/nicepay/_*` - 세션 관리: `/api/v1/auth/_*` 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface CreateSubscriptionSessionRequest
 */
export interface CreateSubscriptionSessionRequest {
    /**
     * 구독할 플랜 ID
     * @type {string}
     * @memberof CreateSubscriptionSessionRequest
     */
    'planId': string;
    /**
     * 사용자 ID
     * @type {string}
     * @memberof CreateSubscriptionSessionRequest
     */
    'userId'?: string;
    /**
     * 플랜 코드 (백엔드에서 플랜 검색에 사용)
     * @type {string}
     * @memberof CreateSubscriptionSessionRequest
     */
    'productPlanCode'?: string;
    /**
     * 결제 완료 후 리다이렉트 URL
     * @type {string}
     * @memberof CreateSubscriptionSessionRequest
     */
    'redirectUrl'?: string;
    /**
     * 추가 메타데이터
     * @type {object}
     * @memberof CreateSubscriptionSessionRequest
     */
    'metadata'?: object;
}

